<div class="container">
  <div class="row m-5 d-flex justify-content-center">
    <div class="col-4">
      <div class="card card-pointer p-3 border border-primary border-5" (click)="rutas('/bandeja-programador')">
        <img src="../../assets/logo/programmer.png" class="card-img-top" alt="..." srcset="">
        <br>
        <div class="d-flex justify-content-center">
          <h5 class="fw-bold">Bandeja programador</h5>
        </div>
      </div>
    </div>
</div>